<template>
    <div>
        <main-navigation></main-navigation>
        <blog-list/>
    </div>
</template>

<script>

    import MainNavigation from '../../layout/MainNavigation.vue';
    import BlogList from './UserBlogList.vue';
    import Icon from "../../ui/Icon";

    export default {
        name: 'UserBlogsPage',
        metaInfo: {
            title: 'Your Blogs'
        },
        data() {
            return {}
        },
        created() {

        },
        methods: {},
        components: {
          Icon,
            MainNavigation,
            BlogList
        }
    }
</script>

<style lang="sass">

</style>



// WEBPACK FOOTER //
// src/components/user/blogs/UserBlogsListPage.vue